import {
  Companion_instance1pnby10k4drrs as Companion_instance,
  Companion_instance1bxyifpo36xxj as Companion_instance_0,
  Companion_instance3gb3zm5gnr6a5 as Companion_instance_1,
  Companion_instance218unjc9ltn4s as Companion_instance_2,
  Never_getInstance32s86skpi7zck as Never_getInstance,
  Always_getInstancecs10mhg5aot2 as Always_getInstance,
  Companion_instance3axtksx96wcm8 as Companion_instance_3,
  Companion_instance3kfd7pkebp1l6 as Companion_instance_4,
  Companion_instance1kshdbaa2euyc as Companion_instance_5,
  Companion_instance3ak5m32y5x4a2 as Companion_instance_6,
  Companion_instance3rhh32thymhrm as Companion_instance_7,
  Companion_instanceykgiia56hplq as Companion_instance_8,
  Companion_instance1wmugroxx6its as Companion_instance_9,
  Conditionuclxcm24fzd9 as Condition,
  Companion_instancek13g6rikuawd as Companion_instance_10,
  And3abx79zpqd7r8 as And,
  Or3lq77uaxl3wr0 as Or,
  Not1k5e2vlrceq68 as Not,
  Equal3ow85705ftxfk as Equal,
  NotEqual12qw5zp9xbgnd as NotEqual,
  Inside39cktoz42t35z as Inside,
  NotInside2db9qer39ktxf as NotInside,
  GreaterThan2wk647zyknocd as GreaterThan,
  LessThankb2oaehgm1o9 as LessThan,
  GreaterThanOrEqualhh0t265tpr4s as GreaterThanOrEqual,
  LessThanOrEqual3qv1kgxmn1wy as LessThanOrEqual,
  IntBitsClear24ickx5y259jy as IntBitsClear,
  IntBitsSet382z2e9l593cy as IntBitsSet,
  IntBitsAnyClear2gpw670obzya9 as IntBitsAnyClear,
  IntBitsAnySetbikmbua6gn9s as IntBitsAnySet,
  ListAllElements37v3iva2v7nna as ListAllElements,
  ListAnyElements3qzxczea8im7z as ListAnyElements,
  ListSizesEqualsndkuh8n9g3vb as ListSizesEquals,
  SetAllElements1q4mlxrpjpkix as SetAllElements,
  SetAnyElements2ckwqq78ogad0 as SetAnyElements,
  SetSizesEqualsooda5aj1zhty as SetSizesEquals,
  Exists42par4hiiuoz as Exists,
  IfNotNull13ixxkuz43ozs as IfNotNull,
  Companion_instance2ro4l92elzn9p as Companion_instance_11,
  Companion_getInstancej2hha9qybp58 as Companion_getInstance,
  Companion_instance393e5hna3az6 as Companion_instance_12,
  Companion_getInstance3i17w8wcrpav1 as Companion_getInstance_0,
  Companion_instance3uymr7onrbkwm as Companion_instance_13,
  Companion_instance1fklk3p9r3exr as Companion_instance_14,
  Companion_instance3a5r5sd3blktl as Companion_instance_15,
  Companion_instance1wdeuj7afw8ax as Companion_instance_16,
  Companion_instancexmfl72rqr3f8 as Companion_instance_17,
  Companion_instance1fynquy6dsj9i as Companion_instance_18,
  Companion_getInstanceltmei8szg1mh as Companion_getInstance_1,
  OnField23al9ljlbymf9 as OnField,
  GeoDistancewu4mc8tux7go as GeoDistance,
  StringContains38lplog8dg7er as StringContains,
  RegexMatches3bf1egw4rhxym as RegexMatches,
  Never1qlvyqx796jr1 as Never,
  Always2zzuixun3eunx as Always,
  RawStringContains2aah1oj1an1a9 as RawStringContains,
  OnKeymlp0tbupd08v as OnKey,
  FullTextSearch2rlpx79w2gy53 as FullTextSearch,
  Companion_instance2l9p65638ljnl as Companion_instance_19,
  Companion_instance1tkgi2p65guqx as Companion_instance_20,
  Companion_instance17kutko0aqeid as Companion_instance_21,
  Companion_instance2ox6qhwp298su as Companion_instance_22,
  Companion_instance2djixj65v0cw7 as Companion_instance_23,
  Companion_instance4ohr4qgu4dpv as Companion_instance_24,
  Companion_instance286iy1cgt2utf as Companion_instance_25,
} from './Condition.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Optionfkzl7z5pdoc9 as Option,
  MySealedClassSerializer11mxzpb8qyqe6 as MySealedClassSerializer,
  MySealedClassSerializerInterface2tzma5kn4becp as MySealedClassSerializerInterface,
} from './MySealedClassSerializer.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  KSerializerKeys3rcxhak3gf5 as KSerializerKey,
  innerElement3bfmmmhd9fksr as innerElement,
  innerElement27ac4km1wtjgu as innerElement2,
  WrappingSerializer3cq24ex5vrdbg as WrappingSerializer,
} from '../serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstancejecdfbtr9cdw as Companion_getInstance_2 } from '../StringAlts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from '../serialization/Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1hu9wv9at41ww as serializer,
  get_nullable197rfua9r7fsz as get_nullable,
  serializer1x79l67jvwntn as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_1 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { GeoCoordinatemhej4memzolm as GeoCoordinate } from '../GeoCoordinate.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_intOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return intOptions;
}
var intOptions;
function get_geocoordinateOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return geocoordinateOptions;
}
var geocoordinateOptions;
function get_stringOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return stringOptions;
}
var stringOptions;
function get_cache() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return cache;
}
var cache;
function comparableOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(inner);
  var tmp_0 = Companion_instance.d2j(inner);
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, comparableOptions$lambda);
  var tmp_2 = Companion_instance_0.d2j(inner);
  var tmp_3 = new (Option())(tmp_2, VOID, VOID, comparableOptions$lambda_0);
  var tmp_4 = Companion_instance_1.d2j(inner);
  var tmp_5 = new (Option())(tmp_4, VOID, VOID, comparableOptions$lambda_1);
  var tmp_6 = Companion_instance_2.d2j(inner);
  return plus(tmp, listOf([tmp_1, tmp_3, tmp_5, new (Option())(tmp_6, VOID, VOID, comparableOptions$lambda_2)]));
}
function commonOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = Never_getInstance().m2a();
  var tmp_0 = new (Option())(tmp, VOID, VOID, commonOptions$lambda);
  var tmp_1 = Always_getInstance().m2a();
  var tmp_2 = new (Option())(tmp_1, VOID, VOID, commonOptions$lambda_0);
  var tmp_3 = Companion_instance_3.d2j(inner);
  var tmp_4 = new (Option())(tmp_3, VOID, VOID, commonOptions$lambda_1);
  var tmp_5 = Companion_instance_4.d2j(inner);
  var tmp_6 = new (Option())(tmp_5, VOID, VOID, commonOptions$lambda_2);
  var tmp_7 = Companion_instance_5.d2j(inner);
  var tmp_8 = new (Option())(tmp_7, VOID, VOID, commonOptions$lambda_3);
  var tmp_9 = Companion_instance_6.d2j(inner);
  var tmp_10 = new (Option())(tmp_9, VOID, VOID, commonOptions$lambda_4);
  var tmp_11 = Companion_instance_7.d2j(inner);
  var tmp_12 = new (Option())(tmp_11, VOID, VOID, commonOptions$lambda_5);
  var tmp_13 = Companion_instance_8.d2j(inner);
  var tmp_14 = new (Option())(tmp_13, VOID, VOID, commonOptions$lambda_6);
  var tmp_15 = Companion_instance_9.d2j(inner);
  return listOf([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, new (Option())(tmp_15, VOID, VOID, commonOptions$lambda_7)]);
}
var ConditionSerializerClass;
function ConditionSerializer() {
  if (ConditionSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        var tmp = this;
        var tmp0 = get_cache();
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().r3t(inner);
        var value = tmp0.p3(key);
        var tmp_0;
        if (value == null) {
          var answer = new (MySealedClassSerializer())('com.lightningkite.lightningdb.Condition', () => {
            var tmp;
            if (inner.az().l11()) {
              var tmp_0 = innerElement(inner);
              tmp = nullableOptions(isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE());
            } else if (substringBefore(inner.az().h10(), _Char___init__impl__6a9atx(47)) === 'kotlin.String') {
              tmp = get_stringOptions();
            } else if (Companion_getInstance_2().i3n_1.t1(inner.az().h10())) {
              tmp = rawStringOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (inner.az().h10() === 'kotlin.Int') {
              tmp = get_intOptions();
            } else if (substringBefore(inner.az().h10(), _Char___init__impl__6a9atx(47)) === 'com.lightningkite.GeoCoordinate') {
              tmp = get_geocoordinateOptions();
            } else if (equals(inner.az().s11(), MAP_getInstance())) {
              tmp = stringMapOptions(innerElement2(inner));
            } else if (equals(inner.az().s11(), LIST_getInstance())) {
              tmp = contains(inner.az().h10(), 'Set') ? setOptions(innerElement(inner)) : listOptions(innerElement(inner));
            } else if (!(get_serializableProperties(inner) == null)) {
              tmp = classOptionsReflective(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else {
              tmp = comparableOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            }
            var r = tmp;
            return isInterface(r, KtList()) ? r : THROW_CCE();
          });
          tmp0.s3(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        var tmp_1 = tmp_0;
        tmp.s3t_1 = isInterface(tmp_1, MySealedClassSerializerInterface()) ? tmp_1 : THROW_CCE();
        this.t3t_1 = inner;
        this.u3t_1 = Never_getInstance();
      }
      z3m() {
        return this.u3t_1;
      }
      v3t() {
        return this.s3t_1.v3t();
      }
      az() {
        return this.s3t_1.az();
      }
      w3t(encoder, value) {
        this.s3t_1.oz(encoder, value);
      }
      oz(encoder, value) {
        return this.w3t(encoder, value instanceof Condition() ? value : THROW_CCE());
      }
      pz(decoder) {
        return this.s3t_1.pz(decoder);
      }
    }
    initMetadataForClass($, 'ConditionSerializer', VOID, VOID, [MySealedClassSerializerInterface(), KSerializerWithDefault()]);
    ConditionSerializerClass = $;
  }
  return ConditionSerializerClass;
}
var LazyRenamedSerialDescriptorClass;
function LazyRenamedSerialDescriptor() {
  if (LazyRenamedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, getter) {
        this.x3t_1 = serialName;
        this.y3t_1 = getter;
      }
      h10() {
        return this.x3t_1;
      }
      u11() {
        return this.y3t_1().u11();
      }
      s11() {
        return this.y3t_1().s11();
      }
      x11(index) {
        return this.y3t_1().x11(index);
      }
      y11(index) {
        return this.y3t_1().y11(index);
      }
      w11(name) {
        return this.y3t_1().w11(name);
      }
      v11(index) {
        return this.y3t_1().v11(index);
      }
      z11(index) {
        return this.y3t_1().z11(index);
      }
    }
    protoOf($).l11 = get_isNullable;
    protoOf($).t11 = get_isInline;
    protoOf($).bz = get_annotations;
    initMetadataForClass($, 'LazyRenamedSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    LazyRenamedSerialDescriptorClass = $;
  }
  return LazyRenamedSerialDescriptorClass;
}
var ConditionAndSerializerClass;
function ConditionAndSerializer() {
  if (ConditionAndSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('And');
        this.c3u_1 = inner;
      }
      d3u() {
        return ListSerializer(Companion_instance_10.d2j(this.c3u_1));
      }
      e3u(it) {
        return it.v3q_1;
      }
      f3u(it) {
        return this.e3u(it instanceof And() ? it : THROW_CCE());
      }
      g3u(it) {
        return And().w3q(it);
      }
      h3u(it) {
        return this.g3u((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionAndSerializer');
    ConditionAndSerializerClass = $;
  }
  return ConditionAndSerializerClass;
}
var ConditionOrSerializerClass;
function ConditionOrSerializer() {
  if (ConditionOrSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Or');
        this.q3u_1 = inner;
      }
      d3u() {
        return ListSerializer(Companion_instance_10.d2j(this.q3u_1));
      }
      r3u(it) {
        return it.y3q_1;
      }
      f3u(it) {
        return this.r3u(it instanceof Or() ? it : THROW_CCE());
      }
      g3u(it) {
        return Or().z3q(it);
      }
      h3u(it) {
        return this.g3u((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionOrSerializer');
    ConditionOrSerializerClass = $;
  }
  return ConditionOrSerializerClass;
}
var ConditionNotSerializerClass;
function ConditionNotSerializer() {
  if (ConditionNotSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Not');
        this.v3u_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.v3u_1);
      }
      w3u(it) {
        return it.b3r_1;
      }
      f3u(it) {
        return this.w3u(it instanceof Not() ? it : THROW_CCE());
      }
      x3u(it) {
        return Not().c3r(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionNotSerializer');
    ConditionNotSerializerClass = $;
  }
  return ConditionNotSerializerClass;
}
var ConditionEqualSerializerClass;
function ConditionEqualSerializer() {
  if (ConditionEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Equal');
        this.b3v_1 = inner;
      }
      d3u() {
        return this.b3v_1;
      }
      c3v(it) {
        return it.d3r_1;
      }
      f3u(it) {
        return this.c3v(it instanceof Equal() ? it : THROW_CCE());
      }
      d3v(it) {
        return Equal().e3r(it);
      }
      h3u(it) {
        return this.d3v((it == null ? true : !(it == null)) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionEqualSerializer');
    ConditionEqualSerializerClass = $;
  }
  return ConditionEqualSerializerClass;
}
var ConditionNotEqualSerializerClass;
function ConditionNotEqualSerializer() {
  if (ConditionNotEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('NotEqual');
        this.h3v_1 = inner;
      }
      d3u() {
        return this.h3v_1;
      }
      i3v(it) {
        return it.f3r_1;
      }
      f3u(it) {
        return this.i3v(it instanceof NotEqual() ? it : THROW_CCE());
      }
      d3v(it) {
        return NotEqual().g3r(it);
      }
      h3u(it) {
        return this.d3v((it == null ? true : !(it == null)) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionNotEqualSerializer');
    ConditionNotEqualSerializerClass = $;
  }
  return ConditionNotEqualSerializerClass;
}
var ConditionInsideSerializerClass;
function ConditionInsideSerializer() {
  if (ConditionInsideSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Inside');
        this.m3v_1 = inner;
      }
      d3u() {
        return ListSerializer(this.m3v_1);
      }
      n3v(it) {
        return it.h3r_1;
      }
      f3u(it) {
        return this.n3v(it instanceof Inside() ? it : THROW_CCE());
      }
      o3v(it) {
        return Inside().i3r(it);
      }
      h3u(it) {
        return this.o3v((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionInsideSerializer');
    ConditionInsideSerializerClass = $;
  }
  return ConditionInsideSerializerClass;
}
var ConditionNotInsideSerializerClass;
function ConditionNotInsideSerializer() {
  if (ConditionNotInsideSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('NotInside');
        this.s3v_1 = inner;
      }
      d3u() {
        return ListSerializer(this.s3v_1);
      }
      t3v(it) {
        return it.j3r_1;
      }
      f3u(it) {
        return this.t3v(it instanceof NotInside() ? it : THROW_CCE());
      }
      o3v(it) {
        return NotInside().k3r(it);
      }
      h3u(it) {
        return this.o3v((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionNotInsideSerializer');
    ConditionNotInsideSerializerClass = $;
  }
  return ConditionNotInsideSerializerClass;
}
var ConditionGreaterThanSerializerClass;
function ConditionGreaterThanSerializer() {
  if (ConditionGreaterThanSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('GreaterThan');
        this.x3v_1 = inner;
      }
      d3u() {
        return this.x3v_1;
      }
      y3v(it) {
        return it.l3r_1;
      }
      f3u(it) {
        return this.y3v(it instanceof GreaterThan() ? it : THROW_CCE());
      }
      z3v(it) {
        return GreaterThan().m3r(it);
      }
      h3u(it) {
        return this.z3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionGreaterThanSerializer');
    ConditionGreaterThanSerializerClass = $;
  }
  return ConditionGreaterThanSerializerClass;
}
var ConditionLessThanSerializerClass;
function ConditionLessThanSerializer() {
  if (ConditionLessThanSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('LessThan');
        this.d3w_1 = inner;
      }
      d3u() {
        return this.d3w_1;
      }
      e3w(it) {
        return it.o3r_1;
      }
      f3u(it) {
        return this.e3w(it instanceof LessThan() ? it : THROW_CCE());
      }
      z3v(it) {
        return LessThan().p3r(it);
      }
      h3u(it) {
        return this.z3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionLessThanSerializer');
    ConditionLessThanSerializerClass = $;
  }
  return ConditionLessThanSerializerClass;
}
var ConditionGreaterThanOrEqualSerializerClass;
function ConditionGreaterThanOrEqualSerializer() {
  if (ConditionGreaterThanOrEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('GreaterThanOrEqual');
        this.i3w_1 = inner;
      }
      d3u() {
        return this.i3w_1;
      }
      j3w(it) {
        return it.q3r_1;
      }
      f3u(it) {
        return this.j3w(it instanceof GreaterThanOrEqual() ? it : THROW_CCE());
      }
      z3v(it) {
        return GreaterThanOrEqual().r3r(it);
      }
      h3u(it) {
        return this.z3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionGreaterThanOrEqualSerializer');
    ConditionGreaterThanOrEqualSerializerClass = $;
  }
  return ConditionGreaterThanOrEqualSerializerClass;
}
var ConditionLessThanOrEqualSerializerClass;
function ConditionLessThanOrEqualSerializer() {
  if (ConditionLessThanOrEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('LessThanOrEqual');
        this.n3w_1 = inner;
      }
      d3u() {
        return this.n3w_1;
      }
      o3w(it) {
        return it.s3r_1;
      }
      f3u(it) {
        return this.o3w(it instanceof LessThanOrEqual() ? it : THROW_CCE());
      }
      z3v(it) {
        return LessThanOrEqual().t3r(it);
      }
      h3u(it) {
        return this.z3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionLessThanOrEqualSerializer');
    ConditionLessThanOrEqualSerializerClass = $;
  }
  return ConditionLessThanOrEqualSerializerClass;
}
var ConditionIntBitsClearSerializerClass;
function ConditionIntBitsClearSerializer() {
  if (ConditionIntBitsClearSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsClearSerializer_instance = null;
        super('IntBitsClear');
        ConditionIntBitsClearSerializer_instance = this;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      s3w(it) {
        return it.f3s_1;
      }
      f3u(it) {
        return this.s3w(it instanceof IntBitsClear() ? it : THROW_CCE());
      }
      t3w(it) {
        return IntBitsClear().g3s(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsClearSerializer');
    ConditionIntBitsClearSerializerClass = $;
  }
  return ConditionIntBitsClearSerializerClass;
}
var ConditionIntBitsClearSerializer_instance;
function ConditionIntBitsClearSerializer_getInstance() {
  if (ConditionIntBitsClearSerializer_instance === VOID)
    new (ConditionIntBitsClearSerializer())();
  return ConditionIntBitsClearSerializer_instance;
}
var ConditionIntBitsSetSerializerClass;
function ConditionIntBitsSetSerializer() {
  if (ConditionIntBitsSetSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsSetSerializer_instance = null;
        super('IntBitsSet');
        ConditionIntBitsSetSerializer_instance = this;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      x3w(it) {
        return it.i3s_1;
      }
      f3u(it) {
        return this.x3w(it instanceof IntBitsSet() ? it : THROW_CCE());
      }
      t3w(it) {
        return IntBitsSet().j3s(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsSetSerializer');
    ConditionIntBitsSetSerializerClass = $;
  }
  return ConditionIntBitsSetSerializerClass;
}
var ConditionIntBitsSetSerializer_instance;
function ConditionIntBitsSetSerializer_getInstance() {
  if (ConditionIntBitsSetSerializer_instance === VOID)
    new (ConditionIntBitsSetSerializer())();
  return ConditionIntBitsSetSerializer_instance;
}
var ConditionIntBitsAnyClearSerializerClass;
function ConditionIntBitsAnyClearSerializer() {
  if (ConditionIntBitsAnyClearSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsAnyClearSerializer_instance = null;
        super('IntBitsAnyClear');
        ConditionIntBitsAnyClearSerializer_instance = this;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      b3x(it) {
        return it.k3s_1;
      }
      f3u(it) {
        return this.b3x(it instanceof IntBitsAnyClear() ? it : THROW_CCE());
      }
      t3w(it) {
        return IntBitsAnyClear().l3s(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsAnyClearSerializer');
    ConditionIntBitsAnyClearSerializerClass = $;
  }
  return ConditionIntBitsAnyClearSerializerClass;
}
var ConditionIntBitsAnyClearSerializer_instance;
function ConditionIntBitsAnyClearSerializer_getInstance() {
  if (ConditionIntBitsAnyClearSerializer_instance === VOID)
    new (ConditionIntBitsAnyClearSerializer())();
  return ConditionIntBitsAnyClearSerializer_instance;
}
var ConditionIntBitsAnySetSerializerClass;
function ConditionIntBitsAnySetSerializer() {
  if (ConditionIntBitsAnySetSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsAnySetSerializer_instance = null;
        super('IntBitsAnySet');
        ConditionIntBitsAnySetSerializer_instance = this;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      f3x(it) {
        return it.m3s_1;
      }
      f3u(it) {
        return this.f3x(it instanceof IntBitsAnySet() ? it : THROW_CCE());
      }
      t3w(it) {
        return IntBitsAnySet().n3s(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsAnySetSerializer');
    ConditionIntBitsAnySetSerializerClass = $;
  }
  return ConditionIntBitsAnySetSerializerClass;
}
var ConditionIntBitsAnySetSerializer_instance;
function ConditionIntBitsAnySetSerializer_getInstance() {
  if (ConditionIntBitsAnySetSerializer_instance === VOID)
    new (ConditionIntBitsAnySetSerializer())();
  return ConditionIntBitsAnySetSerializer_instance;
}
var ConditionListAllElementsSerializerClass;
function ConditionListAllElementsSerializer() {
  if (ConditionListAllElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListAllElements');
        this.j3x_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.j3x_1);
      }
      k3x(it) {
        return it.o3s_1;
      }
      f3u(it) {
        return this.k3x(it instanceof ListAllElements() ? it : THROW_CCE());
      }
      x3u(it) {
        return ListAllElements().p3s(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListAllElementsSerializer');
    ConditionListAllElementsSerializerClass = $;
  }
  return ConditionListAllElementsSerializerClass;
}
var ConditionListAnyElementsSerializerClass;
function ConditionListAnyElementsSerializer() {
  if (ConditionListAnyElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListAnyElements');
        this.o3x_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.o3x_1);
      }
      p3x(it) {
        return it.r3s_1;
      }
      f3u(it) {
        return this.p3x(it instanceof ListAnyElements() ? it : THROW_CCE());
      }
      x3u(it) {
        return ListAnyElements().s3s(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListAnyElementsSerializer');
    ConditionListAnyElementsSerializerClass = $;
  }
  return ConditionListAnyElementsSerializerClass;
}
var ConditionListSizesEqualsSerializerClass;
function ConditionListSizesEqualsSerializer() {
  if (ConditionListSizesEqualsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListSizesEquals');
        this.t3x_1 = inner;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      u3x(it) {
        return it.t3s_1;
      }
      f3u(it) {
        return this.u3x(it instanceof ListSizesEquals() ? it : THROW_CCE());
      }
      t3w(it) {
        return ListSizesEquals().u3s(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListSizesEqualsSerializer');
    ConditionListSizesEqualsSerializerClass = $;
  }
  return ConditionListSizesEqualsSerializerClass;
}
var ConditionSetAllElementsSerializerClass;
function ConditionSetAllElementsSerializer() {
  if (ConditionSetAllElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetAllElements');
        this.y3x_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.y3x_1);
      }
      z3x(it) {
        return it.v3s_1;
      }
      f3u(it) {
        return this.z3x(it instanceof SetAllElements() ? it : THROW_CCE());
      }
      x3u(it) {
        return SetAllElements().w3s(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetAllElementsSerializer');
    ConditionSetAllElementsSerializerClass = $;
  }
  return ConditionSetAllElementsSerializerClass;
}
var ConditionSetAnyElementsSerializerClass;
function ConditionSetAnyElementsSerializer() {
  if (ConditionSetAnyElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetAnyElements');
        this.d3y_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.d3y_1);
      }
      e3y(it) {
        return it.y3s_1;
      }
      f3u(it) {
        return this.e3y(it instanceof SetAnyElements() ? it : THROW_CCE());
      }
      x3u(it) {
        return SetAnyElements().z3s(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetAnyElementsSerializer');
    ConditionSetAnyElementsSerializerClass = $;
  }
  return ConditionSetAnyElementsSerializerClass;
}
var ConditionSetSizesEqualsSerializerClass;
function ConditionSetSizesEqualsSerializer() {
  if (ConditionSetSizesEqualsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetSizesEquals');
        this.i3y_1 = inner;
      }
      d3u() {
        return serializer(IntCompanionObject_instance);
      }
      j3y(it) {
        return it.a3t_1;
      }
      f3u(it) {
        return this.j3y(it instanceof SetSizesEquals() ? it : THROW_CCE());
      }
      t3w(it) {
        return SetSizesEquals().b3t(it);
      }
      h3u(it) {
        return this.t3w((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetSizesEqualsSerializer');
    ConditionSetSizesEqualsSerializerClass = $;
  }
  return ConditionSetSizesEqualsSerializerClass;
}
var ConditionExistsSerializerClass;
function ConditionExistsSerializer() {
  if (ConditionExistsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Exists');
        this.n3y_1 = inner;
      }
      d3u() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        return isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
      }
      o3y(it) {
        return it.c3t_1;
      }
      f3u(it) {
        return this.o3y(it instanceof Exists() ? it : THROW_CCE());
      }
      p3y(it) {
        return Exists().d3t(it);
      }
      h3u(it) {
        return this.p3y((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionExistsSerializer');
    ConditionExistsSerializerClass = $;
  }
  return ConditionExistsSerializerClass;
}
var ConditionIfNotNullSerializerClass;
function ConditionIfNotNullSerializer() {
  if (ConditionIfNotNullSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('IfNotNull');
        this.t3y_1 = inner;
      }
      d3u() {
        return Companion_instance_10.d2j(this.t3y_1);
      }
      u3y(it) {
        return it.j3t_1;
      }
      f3u(it) {
        return this.u3y(it instanceof IfNotNull() ? it : THROW_CCE());
      }
      x3u(it) {
        return IfNotNull().k3t(it);
      }
      h3u(it) {
        return this.x3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionIfNotNullSerializer');
    ConditionIfNotNullSerializerClass = $;
  }
  return ConditionIfNotNullSerializerClass;
}
function nullableOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(get_nullable(inner));
  var tmp_0 = Companion_instance_11.d2j(inner);
  return plus(tmp, listOf_0(new (Option())(tmp_0, VOID, VOID, nullableOptions$lambda)));
}
function rawStringOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = comparableOptions(element);
  var tmp_0 = Companion_getInstance().d2j(element);
  var tmp_1 = setOf('Search');
  return plus(tmp, listOf_0(new (Option())(tmp_0, tmp_1, VOID, rawStringOptions$lambda)));
}
function stringMapOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(MapSerializer(serializer_0(StringCompanionObject_instance), element));
  var tmp_0 = Companion_instance_12.d3l(element);
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, stringMapOptions$lambda);
  var tmp_2 = Companion_getInstance_0().d3l(element);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, VOID, VOID, stringMapOptions$lambda_0)]));
}
function setOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(SetSerializer(element));
  var tmp_0 = Companion_instance_13.c3l(element);
  var tmp_1 = setOf_0(['ListAllElements', 'AllElements']);
  var tmp_2 = new (Option())(tmp_0, tmp_1, VOID, setOptions$lambda);
  var tmp_3 = Companion_instance_14.c3l(element);
  var tmp_4 = setOf_0(['ListAnyElements', 'AnyElements']);
  var tmp_5 = new (Option())(tmp_3, tmp_4, VOID, setOptions$lambda_0);
  var tmp_6 = Companion_instance_15.c3l(element);
  var tmp_7 = setOf_0(['ListSizesEquals', 'SizesEquals']);
  return plus(tmp, listOf([tmp_2, tmp_5, new (Option())(tmp_6, tmp_7, VOID, setOptions$lambda_1)]));
}
function listOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(ListSerializer(element));
  var tmp_0 = Companion_instance_16.c3l(element);
  var tmp_1 = setOf_0(['SetAllElements', 'AllElements']);
  var tmp_2 = new (Option())(tmp_0, tmp_1, VOID, listOptions$lambda);
  var tmp_3 = Companion_instance_17.c3l(element);
  var tmp_4 = setOf_0(['SetAnyElements', 'AnyElements']);
  var tmp_5 = new (Option())(tmp_3, tmp_4, VOID, listOptions$lambda_0);
  var tmp_6 = Companion_instance_18.c3l(element);
  var tmp_7 = setOf_0(['SetSizesEquals', 'SizesEquals']);
  return plus(tmp, listOf([tmp_2, tmp_5, new (Option())(tmp_6, tmp_7, VOID, listOptions$lambda_1)]));
}
function classOptionsReflective(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(inner);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = ensureNotNull(get_serializableProperties(inner));
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().u(this_0.length);
  var index = 0;
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp_0 = new (ConditionOnFieldSerializer())(isInterface(item, SerializableProperty()) ? item : THROW_CCE());
    var tmp$ret$0 = new (Option())(tmp_0, VOID, VOID, classOptionsReflective$lambda(inner, _unary__edvuaz));
    destination.v(tmp$ret$0);
  }
  var tmp_1 = plus(tmp, destination);
  var tmp_2 = Companion_getInstance_1().d2j(inner);
  return plus_0(tmp_1, new (Option())(tmp_2, VOID, VOID, classOptionsReflective$lambda_0));
}
var ConditionOnFieldSerializerClass;
function ConditionOnFieldSerializer() {
  if (ConditionOnFieldSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(field) {
        super(field.k20());
        this.y3y_1 = field;
      }
      d3u() {
        return Companion_instance_10.d2j(this.y3y_1.j2j());
      }
      z3y(it) {
        return it.g3t_1;
      }
      f3u(it) {
        return this.z3y(it instanceof OnField() ? it : THROW_CCE());
      }
      a3z(it) {
        return OnField().h3t(this.y3y_1, it);
      }
      h3u(it) {
        return this.a3z(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionOnFieldSerializer');
    ConditionOnFieldSerializerClass = $;
  }
  return ConditionOnFieldSerializerClass;
}
function intOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsClear();
}
function intOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsSet();
}
function intOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsAnyClear();
}
function intOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsAnySet();
}
function geocoordinateOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GeoDistance();
}
function stringOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof StringContains();
}
function stringOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof RegexMatches();
}
function comparableOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GreaterThan();
}
function comparableOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof LessThan();
}
function comparableOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GreaterThanOrEqual();
}
function comparableOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof LessThanOrEqual();
}
function commonOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Never();
}
function commonOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Always();
}
function commonOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof And();
}
function commonOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Or();
}
function commonOptions$lambda_3(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Not();
}
function commonOptions$lambda_4(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Equal();
}
function commonOptions$lambda_5(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof NotEqual();
}
function commonOptions$lambda_6(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Inside();
}
function commonOptions$lambda_7(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof NotInside();
}
function nullableOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IfNotNull();
}
function rawStringOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof RawStringContains();
}
function stringMapOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Exists();
}
function stringMapOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof OnKey();
}
function setOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetAllElements();
}
function setOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetAnyElements();
}
function setOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetSizesEquals();
}
function listOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListAllElements();
}
function listOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListAnyElements();
}
function listOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListSizesEquals();
}
function classOptionsReflective$lambda($inner, $index) {
  return (it) => {
    var tmp;
    if (it instanceof OnField()) {
      tmp = it.f3t_1.k20() === $inner.az().v11($index);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function classOptionsReflective$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof FullTextSearch();
}
var properties_initialized_ConditionSerialization_kt_o807ux;
function _init_properties_ConditionSerialization_kt__gb1zm3() {
  if (!properties_initialized_ConditionSerialization_kt_o807ux) {
    properties_initialized_ConditionSerialization_kt_o807ux = true;
    var tmp = comparableOptions(serializer(IntCompanionObject_instance));
    var tmp_0 = Companion_instance_19.m2a();
    var tmp_1 = new (Option())(tmp_0, VOID, VOID, intOptions$lambda);
    var tmp_2 = Companion_instance_20.m2a();
    var tmp_3 = new (Option())(tmp_2, VOID, VOID, intOptions$lambda_0);
    var tmp_4 = Companion_instance_21.m2a();
    var tmp_5 = new (Option())(tmp_4, VOID, VOID, intOptions$lambda_1);
    var tmp_6 = Companion_instance_22.m2a();
    intOptions = plus(tmp, listOf([tmp_1, tmp_3, tmp_5, new (Option())(tmp_6, VOID, VOID, intOptions$lambda_2)]));
    var tmp_7 = commonOptions(ContextualSerializer().kz(getKClass(GeoCoordinate())));
    var tmp_8 = Companion_instance_23.m2a();
    geocoordinateOptions = plus(tmp_7, listOf_0(new (Option())(tmp_8, VOID, VOID, geocoordinateOptions$lambda)));
    var tmp_9 = comparableOptions(serializer_0(StringCompanionObject_instance));
    var tmp_10 = Companion_instance_24.m2a();
    var tmp_11 = setOf('Search');
    var tmp_12 = new (Option())(tmp_10, tmp_11, VOID, stringOptions$lambda);
    var tmp_13 = Companion_instance_25.m2a();
    stringOptions = plus(tmp_9, listOf([tmp_12, new (Option())(tmp_13, VOID, VOID, stringOptions$lambda_0)]));
    cache = HashMap().n8();
  }
}
//region block: exports
export {
  ConditionAndSerializer as ConditionAndSerializershp9a696fdxf,
  ConditionEqualSerializer as ConditionEqualSerializer3n9q0cnonfztj,
  ConditionExistsSerializer as ConditionExistsSerializer2mmkbd3iu2pth,
  ConditionGreaterThanOrEqualSerializer as ConditionGreaterThanOrEqualSerializerd3i5m1nwtoi7,
  ConditionGreaterThanSerializer as ConditionGreaterThanSerializer277dsnyavrmc9,
  ConditionIfNotNullSerializer as ConditionIfNotNullSerializer3cz0ngjdcqx1i,
  ConditionInsideSerializer as ConditionInsideSerializer2dufbf53611bw,
  ConditionLessThanOrEqualSerializer as ConditionLessThanOrEqualSerializer1vvxz52khnx5,
  ConditionLessThanSerializer as ConditionLessThanSerializer1od1ld42d54u4,
  ConditionListAllElementsSerializer as ConditionListAllElementsSerializer3sj93hfexg66j,
  ConditionListAnyElementsSerializer as ConditionListAnyElementsSerializer2q4myqn5rkmn,
  ConditionListSizesEqualsSerializer as ConditionListSizesEqualsSerializer1qwggu7wvog2x,
  ConditionNotEqualSerializer as ConditionNotEqualSerializer20gzmmwowd8le,
  ConditionNotInsideSerializer as ConditionNotInsideSerializer91ftvtxrrk34,
  ConditionNotSerializer as ConditionNotSerializer3ey7lovzblniv,
  ConditionOrSerializer as ConditionOrSerializerwwh3agum1kpd,
  ConditionSerializer as ConditionSerializer21tf3x2n3amih,
  ConditionSetAllElementsSerializer as ConditionSetAllElementsSerializer2x6jg9l2e18xo,
  ConditionSetAnyElementsSerializer as ConditionSetAnyElementsSerializer1k22fozvgrp6w,
  ConditionSetSizesEqualsSerializer as ConditionSetSizesEqualsSerializerlxoe42ppkrqz,
  LazyRenamedSerialDescriptor as LazyRenamedSerialDescriptor35xsl6h8pjd6j,
  ConditionIntBitsAnyClearSerializer_getInstance as ConditionIntBitsAnyClearSerializer_getInstance39t9786jt668y,
  ConditionIntBitsAnySetSerializer_getInstance as ConditionIntBitsAnySetSerializer_getInstance1w3q3n2h75sx1,
  ConditionIntBitsClearSerializer_getInstance as ConditionIntBitsClearSerializer_getInstance2os59x4h1vpfb,
  ConditionIntBitsSetSerializer_getInstance as ConditionIntBitsSetSerializer_getInstance1wuh0zi8t27wz,
};
//endregion

//# sourceMappingURL=ConditionSerialization.mjs.map
